/*eslint-disable */

import axios from 'axios';
import {
  mapGetters
} from 'vuex';
import toast from '@/services/toast';

const $ = window.jQuery = require('jquery'); 


export default {
  name: 'emplooye-task-list',
  components: {},
  props: [],
  data () {
    return {
      employeeTaskList:null,
      employeeTaskListResults:[],
      nextStep:'',
      loadmoreData: {},
      userLoading: false,
      submitted:false,
      countryList:[],
      removeUserFromOurList:false,
      removeUserId:'',
      nextPageUrl:null
    }
  },
  computed: {
  ...mapGetters([
    'getEmployeeTaskListGetters',
  ]),
  getEmployeeTaskListFun(){
   this.employeeTaskList = this.$store.getters.getEmployeeTaskListGetters.data
   return 
  },
  SetIntialStatus() {
    if (this.employeeTaskList) {
      this.nextStep = this.employeeTaskList.next
      this.nextPageUrl = this.employeeTaskList.next
      this.employeeTaskListResults = this.employeeTaskList.results
    }
  },
  },
  mounted () {
    this.getEmployeeTaskListFun
    this.SetIntialStatus 
  },
  methods: {
    getRemoveListAgain() {
      this.$store.dispatch('geEmployeeTaskListFun').then((res) => {
        this.employeeTaskList = res.data.data
      }).catch((err) => {
      })
    },
    showRemovedModalFun(id){
      $("body").addClass("body_right_scroll_remove");
      this.removeUserFromOurList = true
      this.removeUserId = id
    },
    removeModalItemConfirmFun(){
      this.$store.dispatch('removeSaOrgUserFun', {
        id: this.removeUserId,
      })
      .then((res) => {
        if (res.status == '200') {      
          toast.success(res.data.msg); 
          $("body").removeClass("body_right_scroll_remove");
          this.removeUserFromOurList = false
          this.removeUserId = ''
          this.getRemoveListAgain()
        }
      }).catch((err) => {
        toast.error(err.data.user_msg);  
      })
    return;
    },
    closeRemoveItemModalFun(){
      $("body").removeClass("body_right_scroll_remove");
      this.removeUserFromOurList = false
      this.taskDeleteId = ''
    },
    showLoadMoreDataFun(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          this.$set(this.employeeTaskListResults, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.employeeTaskListResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
  },
  watch:{
    nextStep(old_val, new_val){
      if(new_val != ''){
        this.nextPageUrl = new_val
      }
    },
    getEmployeeTaskListFun(){
      return  this.$store.getters.getEmployeeTaskListGetters
    },
    SetIntialStatus() {
      if (this.employeeTaskList) {
        this.employeeTaskListResults = this.employeeTaskList.results
      }
    },
  },
  beforeCreate: function() {
  },
  beforeRouteLeave: function(to, from, next) {
    $("body").removeClass("body_right_scroll_remove");
    next();
  },
}